import { render, staticRenderFns } from "./TransportCreateOrEdit.vue?vue&type=template&id=117ee274&"
import script from "./TransportCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./TransportCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports